/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import { DragDropContainer } from 'react-drag-drop-container';
import Dropzone from 'react-dropzone';
import {ErrorHandle} from '../../Helpers/Helpers';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css'

class UploadRoomImage extends Component {

	constructor(props) {
        super(props);
        this.state = {
			lgShow: false,
			error: false,
			errorText: '',
			preview: [],
			volume: 1.30
        }
        this.flushPreview = this.flushPreview.bind(this);
    }

    handleOnChange = (value) => {
        this.setState({ volume: value })
    }

    onDrop(acceptedFiles, rejectedFiles) {
		if(acceptedFiles.length > 0){
			this.setState({preview: acceptedFiles});
		}
		// Rejected Image
		if(rejectedFiles.length > 0)
			this.setState({ error: true, errorText: 'Image size is too big! Max upload size is 3MB.' });
		else
			this.setState({ error: false, errorText: '' });
	}

	flushPreview = () => {
		this.setState({ preview: [] });
	}

	lgClose = () => {
		this.setState({ lgShow: false });
	}

 	render() {
 	 	const { preview, error, errorText, volume } = this.state;
 	 	const { canvasImage } = this.props;
        const pStyle = {transform: 'scale('+volume+')'};
	    return (
			<div>
				<a href="#!" onClick={() => this.setState({ lgShow: true })} className="btn btn-primary default-btn">Upload Room Image</a>
				<Modal
					show={this.state.lgShow}
					onHide={this.lgClose}
					bsSize="large"
					aria-labelledby="contained-modal-title-lg"
				>
					<Modal.Header closeButton>
			        	<Modal.Title id="contained-modal-title-lg">Upload Room Image</Modal.Title>
			        </Modal.Header>
					<Modal.Body>
						<ErrorHandle
							error={error}
							errorText={errorText} />
						{preview.length > 0 ?
							<div>
								<a href="#!" onClick={this.flushPreview} className="btn btn-primary default-btn">Use another Room Image</a>
								<div className='slider-horizontal class-zoom'>
									<div className="col-sm-2">
										<div className="row">
											<strong>Zoom In</strong>
										</div>
									</div>
									<div className="col-sm-8">
										<Slider
											min={1}
											max={2}
											step={0.01}
											tooltip={false}
											value={volume}
											orientation="horizontal"
											onChange={this.handleOnChange} />
									</div>
									<div className="col-sm-2 zoom-out-text">
										<div className="row">
											<strong>Zoom Out</strong>
										</div>
									</div>
								</div>
								<div className="modal-room-image-wrapper">
									{preview.map((file) => <img src={file.preview} alt="preview" key="preview" style={{maxHeight: this.props.viewportHeight - 150 +'px'}} /> )}
									<div className="modal-room-image-drag">
										<DragDropContainer>
											<img style={pStyle} src={canvasImage} alt="Room" className="room-canvas-image" />
										</DragDropContainer>
									</div>
								</div>
							</div>
						    :
						    <Dropzone
								accept="image/jpeg, image/png"
								onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
								multiple={false}
								maxSize={33600000}
								className="upload-image-dropzone"
								name="userupload"
							>
								<div className="alert alert-info">
									<strong>Drop files here or click to upload.</strong>
									<span className="dropzone-notes">
										Only *.jpeg and *.png images will be accepted <br />
										Max file size: 32MB <br />
										Contact us for larger files and other formats
									</span>
								</div>
							</Dropzone>
						}
					</Modal.Body>
				</Modal>
			</div>
	    );
  	}
}
export default UploadRoomImage;